import React from 'react'
import { Link } from 'react-router-dom'

function First() {
  return (
    <>
        <section id="team" className="team-area2 pt-120 pb-90" style={{ background: "url(assets/img/bg/aliment-right3.png) no-repeat", backgroundPosition: "right center" }} >
            <div className="container">
                <div className="row align-items-center">
                <div className="col-lg-4 col-md-6">
                    <div className="single-team mb-30 ">
                    <div className="team-thumb">
                        <div className="brd">
                        <img src="assets/img/team/team_img01.png" alt="img" />
                        </div>
                        <div className="social align-items-center">
                        <a href="https://www.facebook.com">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="https://twitter.com">
                            <i className="fab fa-twitter" />
                        </a>
                        <a href="https://www.behance.net">
                            <i className="fab fa-behance" />
                        </a>
                        <a href="https://www.youtube.com">
                            <i className="fab fa-youtube" />
                        </a>
                        </div>
                    </div>
                    <div className="team-info">
                        <h4>
                        <Link to="/teamdeatils">Nashid Martin</Link>
                        </h4>
                        <span>Founder</span>
                    </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="single-team mb-30 ">
                    <div className="team-thumb">
                        <div className="brd">
                        <img src="assets/img/team/team_img02.png" alt="img" />
                        </div>
                        <div className="social align-items-center">
                        <a href="https://www.facebook.com">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="https://twitter.com">
                            <i className="fab fa-twitter" />
                        </a>
                        <a href="https://www.behance.net">
                            <i className="fab fa-behance" />
                        </a>
                        <a href="https://www.youtube.com">
                            <i className="fab fa-youtube" />
                        </a>
                        </div>
                    </div>
                    <div className="team-info">
                        <h4>
                        <Link to="/teamdeatils">Konne Backfi</Link>
                        </h4>
                        <span>CEO</span>
                    </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="single-team mb-30 ">
                    <div className="team-thumb">
                        <div className="brd">
                        <img src="assets/img/team/team_img03.png" alt="img" />
                        </div>
                        <div className="social align-items-center">
                        <a href="https://www.facebook.com">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="https://twitter.com">
                            <i className="fab fa-twitter" />
                        </a>
                        <a href="https://www.behance.net">
                            <i className="fab fa-behance" />
                        </a>
                        <a href="https://www.youtube.com">
                            <i className="fab fa-youtube" />
                        </a>
                        </div>
                    </div>
                    <div className="team-info">
                        <h4>
                        <Link to="/teamdeatils">Hackson Willi</Link>
                        </h4>
                        <span>Developer</span>
                    </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="single-team mb-30 ">
                    <div className="team-thumb">
                        <div className="brd">
                        <img src="assets/img/team/team_img06.png" alt="img" />
                        </div>
                        <div className="social align-items-center">
                        <a href="https://www.facebook.com">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="https://twitter.com">
                            <i className="fab fa-twitter" />
                        </a>
                        <a href="https://www.behance.net">
                            <i className="fab fa-behance" />
                        </a>
                        <a href="https://www.youtube.com">
                            <i className="fab fa-youtube" />
                        </a>
                        </div>
                    </div>
                    <div className="team-info">
                        <h4>
                            <Link to="/teamdeatils">Dekhina Pike</Link>
                        </h4>
                        <span>Founder</span>
                    </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="single-team mb-30 ">
                    <div className="team-thumb">
                        <div className="brd">
                        <img src="assets/img/team/team_img04.png" alt="img" />
                        </div>
                        <div className="social align-items-center">
                        <a href="https://www.facebook.com">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="https://twitter.com">
                            <i className="fab fa-twitter" />
                        </a>
                        <a href="https://www.behance.net">
                            <i className="fab fa-behance" />
                        </a>
                        <a href="https://www.youtube.com">
                            <i className="fab fa-youtube" />
                        </a>
                        </div>
                    </div>
                    <div className="team-info">
                        <h4>
                        <Link to="/teamdeatils">Dekhina Pike</Link>
                        </h4>
                        <span>Founder</span>
                    </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="single-team mb-30 ">
                    <div className="team-thumb">
                        <div className="brd">
                        <img src="assets/img/team/team_img05.png" alt="img" />
                        </div>
                        <div className="social align-items-center">
                        <a href="https://www.facebook.com">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="https://twitter.com">
                            <i className="fab fa-twitter" />
                        </a>
                        <a href="https://www.behance.net">
                            <i className="fab fa-behance" />
                        </a>
                        <a href="https://www.youtube.com">
                            <i className="fab fa-youtube" />
                        </a>
                        </div>
                    </div>
                    <div className="team-info">
                        <h4>
                        <Link to="/teamdeatils">Dekhina Pike</Link>
                        </h4>
                        <span>Founder</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default First